import { render, staticRenderFns } from "./MonthlyIOListMob.vue?vue&type=template&id=4628be16&scoped=true&"
import script from "./MonthlyIOListMob.vue?vue&type=script&lang=js&"
export * from "./MonthlyIOListMob.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyIOListMob.vue?vue&type=style&index=0&id=4628be16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628be16",
  null
  
)

export default component.exports